class Emitter {
    constructor() {
        this.listeners = {};
    }
    emit(eventName, payload) {
        if (this.listeners[eventName]) {
            this.listeners[eventName].forEach((callback) => {
                callback(payload);
            });
        }
    }
    subscribe(eventName, callback) {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(callback);
    }
}
var events = new Emitter();

export { events as default };
//# sourceMappingURL=index.js.map
